export default {
  "tabs": "_tabs_14uk68"
};